import OrganizationInviteContainer from './organization_invite_container';

const OrganizationInvite = OrganizationInviteContainer;
export default OrganizationInvite;
